export default __webpack_public_path__ + "static/media/covid-19.946c5ad0.png";